import React from "react";
import {
	TextField,
	FormControl,
	Select,
	MenuItem,
	Button,
	withStyles,
	ListItem,
	Divider,
	ListItemSecondaryAction,
	IconButton,
	List,
	ListItemText,
	Typography
} from "@material-ui/core";
import { Col, Row } from "react-flexbox-grid";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import PropTypes from "prop-types";
import uuid from "uuid";
import BorderZone from "../../border-zone";

const styles = (theme) => ({
	actions: {
		textAlign: "right"
	},
	textField: {
		marginBottom: 24
	}
});

const resolveOrder = (order) => {
	switch (order) {
		case "ASC":
			return "Ascendente";
		case "DESC":
			return "Descendente";
		default:
			return "";
	}
};

/**
 * Componente para agregar y listar estratificadores
 * @author Jhoan López <jhoanlt19@gmail.com>
 * @param {*} param0
 */
const AddStritifiers = ({
	values,
	helpers,
	classes,
	handleChange,
	setFieldValue
}) => {
	const handleAdd = () => {
		setFieldValue("name", "");
		setFieldValue("stratifiersOrder", "");
		helpers.push({
			id: uuid.v4(),
			name: values.name,
			order: values.stratifiersOrder
		});
	};

	return (
		<Row>
			<BorderZone>
				<Col xs={12}>
					<TextField
						id="outlined-multiline-flexible"
						label="Nombre"
						rowsMax="4"
						margin="normal"
						variant="outlined"
						name="name"
						onChange={handleChange}
						value={values.name}
						className={classes.textField}
						fullWidth
						multiline
						InputLabelProps={{
							shrink: true
						}}
					/>
					<FormControl fullWidth variant="outlined">
						<Typography
							className="text-gray-600"
							style={{ marginLeft: 12 }}
							variant="caption"
						>
							Ordenamiento
						</Typography>
						<Select
							name="stratifiersOrder"
							value={values.stratifiersOrder}
							displayEmpty
							onChange={handleChange}
						>
							<MenuItem value="ASC">Ascendente</MenuItem>
							<MenuItem value="DESC">Descendente</MenuItem>
						</Select>
					</FormControl>
				</Col>
				<Col xs={12} className={classes.actions}>
					<Button
						variant="outlined"
						color="primary"
						onClick={() => handleAdd()}
						style={{ marginTop: 15 }}
						disabled={values.name === "" || values.stratifiersOrder === ""}
					>
						Agregar
						<AddIcon />
					</Button>
				</Col>
			</BorderZone>
			<Col xs={12}>
				<div>
					{values.stratifiers && values.stratifiers.length === 0 ? (
						<Typography gutterTop>No hay estratificadores agregados</Typography>
					) : (
						<Typography gutterTop>Estratificadores agregados</Typography>
					)}
					{values.stratifiers
						? values.stratifiers.map((item, key) => (
								<React.Fragment key={key}>
									<List dense>
										<ListItem>
											<ListItemText
												primary={`${item.name}`}
												secondary={resolveOrder(item.order)}
											/>
											<ListItemSecondaryAction>
												<IconButton
													edge="end"
													aria-label="delete"
													onClick={() => helpers.remove(key)}
												>
													<DeleteIcon />
												</IconButton>
											</ListItemSecondaryAction>
										</ListItem>
									</List>
									<Divider />
								</React.Fragment>
						  ))
						: []}
				</div>
			</Col>
		</Row>
	);
};

AddStritifiers.propTypes = {
	values: PropTypes.object,
	helpers: PropTypes.object,
	classes: PropTypes.object,
	handleChange: PropTypes.func,
	setFieldValue: PropTypes.func
};

export default withStyles(styles)(AddStritifiers);



// WEBPACK FOOTER //
// ./src/components/admin/indicators/addStratifiers.js